/* eslint-disable import/no-internal-modules */
import { useTheme } from '@mui/material/styles';
import { useEffect } from 'react';

import { loadMaterialSymbols } from '../icon';

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        __rubiksFontStylesheetReady?: Promise<void>;
    }
}

export function FontProvider() {
    const theme = useTheme();

    useEffect(() => {
        void loadMaterialSymbols();

        const fontFamily = theme.typography.fontFamily
            ?.split(',')[0]
            .trim()
            .replaceAll("'", '')
            .replaceAll('"', '')
            .toLowerCase();

        const fontStylesheetReady = (async () => {
            switch (fontFamily) {
                case undefined:
                    break;
                case 'inter':
                    await Promise.all([
                        import('@fontsource/inter/300.css'),
                        import('@fontsource/inter/400.css'),
                        import('@fontsource/inter/500.css'),
                        import('@fontsource/inter/600.css'),
                        import('@fontsource/inter/700.css')
                    ]);

                    break;
                case 'roboto':
                    await Promise.all([
                        import('@fontsource/roboto/300.css'),
                        import('@fontsource/roboto/400.css'),
                        import('@fontsource/roboto/500.css'),
                        import('@fontsource/roboto/700.css')
                    ]);

                    break;
                case 'averta':
                    await import('./assets/averta.css');

                    break;
                default:
                    break;
            }

            if (typeof document !== 'undefined') {
                await document.fonts.ready;
                await Promise.all(
                    [300, 400, 500, 600, 700].map((fontWeight) =>
                        document.fonts.load(
                            `${fontWeight} 14px "${fontFamily}"`
                        )
                    )
                );
            }
        })();

        if (typeof window !== 'undefined') {
            window.__rubiksFontStylesheetReady = fontStylesheetReady;
        }
    }, [theme.typography.fontFamily]);

    return null;
}
